import styled from 'styled-components'
import { Button as ButtonComponent, NumberInput } from 'ui'

export const Container = styled.div`
    align-items: center;
    display: flex;
`

export const Button = styled(ButtonComponent)`
    flex-shrink: 0;
`

export const TimeInput = styled(NumberInput)`
    width: 100%;

    &:first-child {
        margin-right: 15px;
    }

    &:last-child {
        margin-left: 15px;
    }
`
